import { isEmpty } from 'lodash'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Button from 'components/common/Button'
import Text from 'components/common/Text'
import { ScenarioRow } from 'components/navigation/Notifications/AttackRows/ScenarioRow'
import { ScenarioHaltConfirmationModal } from 'components/scenarios/detail/ScenarioActions'
import { getRunStage } from 'components/scenarios/utils'
import theme from 'theme'
import { ScenarioRun } from 'types/api/scenarios/runs/scenario-runs'

export const CompletedScenarioList: React.FC<{
  completedScenariosAwaitingResults: ScenarioRun[]
  doFetchCompletedRuns(): void
  closePopover(): void
  selectableRows: boolean
}> = ({
  completedScenariosAwaitingResults,
  doFetchCompletedRuns,
  closePopover,
  selectableRows,
  ...rest
}) => {
  const navigate = useNavigate()
  const handleOnClick = ({ event, scenario }) => {
    event.preventDefault()

    navigate(
      `/scenarios/detail/${scenario.scenario_id}/runs/${scenario.run_number}`,
      {
        state: {
          scrollToResults: true
        }
      }
    )
    closePopover()
    return false
  }

  const [selectedRun, setSelectedRun] = useState<ScenarioRun>({} as ScenarioRun)
  return (
    <>
      {completedScenariosAwaitingResults.map((scenario) => {
        return (
          <ScenarioRow
            key={`${scenario.scenario_id}-${scenario.run_number}`}
            clickableRow
            isScenarioRun
            as="div"
            doFetch={doFetchCompletedRuns}
            extraRowContent={
              <Button
                data-test-input-results
                secondary
                as="button"
                onClick={(event) => {
                  event.preventDefault()
                  setSelectedRun(scenario)
                  return false
                }}
              >
                Input Results
              </Button>
            }
            scenario={scenario}
            selectableRow={selectableRows}
            showHaltButton={false}
            onClick={(event) => {
              if (event.target.tagName !== 'BUTTON') {
                handleOnClick({ event, scenario })
              }
            }}
            {...rest}
          />
        )
      })}
      <ScenarioHaltConfirmationModal
        isCompletedNotification
        isScenarioRun
        confirmButtonType="primary"
        confirmText="Save"
        doFetch={doFetchCompletedRuns}
        haltConfirmationOpen={!isEmpty(selectedRun)}
        hideOverlay={false}
        scenario={selectedRun}
        scenarioId={selectedRun?.scenario_id}
        selectedRun={selectedRun}
        setDisableButton={() => true}
        setHaltConfirmationOpen={setSelectedRun}
        shouldCloseOnOverlayClick={false}
        showHaltButton={false}
        title={
          <div
            css={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column'
            }}
          >
            Scenario Completed
            <Text
              as="small"
              color="medium"
              css={{
                fontSize: theme.fontSizes[1],
                marginTop: theme.space[2]
              }}
            >
              <strong>{selectedRun.name || 'Your scenario'}</strong> has{' '}
              {getRunStage(selectedRun)}
            </Text>
          </div>
        }
      />
    </>
  )
}
